import React from 'react'
import { PagesProgressStyles } from './Style'
import { isNaN } from 'lodash'

const PagesProgress = (props) => {
    const { pagesReadCount, totalPagesCount } = props

    return (
        isNaN(totalPagesCount) ||
        <PagesProgressStyles>
            {[...Array(totalPagesCount)].map((page, index) =>
                <div className='progress-item' key={index}>
                    <div className='page-number'> {index >= pagesReadCount && `${index + 1}`}</div>
                    <div className={`page-progress ${index < pagesReadCount && "completed-page"}`} />
                </div>
            )}
        </PagesProgressStyles>
    )
}

export default PagesProgress